import type { CreateControllerFn } from '@wix/yoshi-flow-editor';
import { bindRouter } from '@wix/tpa-router/plugins';

import {
  initializeRouter,
  registerApplicationRoutes,
  reloadOnLogin,
} from 'controller/router';
import { addLogger } from 'controller/logger';
import { addSeoTagsProvider } from 'controller/seo';
import { resolvables } from 'controller/resolvables';
import { initializeStore, persistStore } from 'controller/store';
import { migrateStyles } from 'controller/tpa-styles-migration';
import { initializeSettingsEventHandler } from 'controller/tpa-settings-events';
import { bindViewModel, initializeViewModel } from 'controller/view-model';
import { bindIntegrations } from 'controller/integrations';
import { initializePlatformApi } from 'controller/viewer-platform';
import { defer } from 'common/utils';

import { config } from './config';
import { resolve } from './resolve';
import { seoTagsProvider } from './seo';

export const controller: CreateControllerFn = function (params) {
  const { flowAPI } = params;

  const ready = defer();
  const router = initializeRouter(params);
  const settingsEvents = initializeSettingsEventHandler(router, params);

  flowAPI.bi?.updateDefaults({ userEntry: 'site' });

  return {
    async pageReady() {
      const store = initializeStore(params);
      const vm = await initializeViewModel(router, store, params);

      addLogger(router, params);
      config(router, params, vm);
      reloadOnLogin(router, params);
      registerApplicationRoutes(router, vm, store, params);
      addSeoTagsProvider(router, params, seoTagsProvider(store, params));

      migrateStyles(params);
      bindViewModel(vm, store, params);
      bindRouter(router, params.flowAPI);

      await resolvables(params, resolve(router, params));

      bindIntegrations(vm);
      persistStore(store, params);

      ready.resolve(initializePlatformApi(router, store, vm));
    },
    updateConfig($w, updatedConfig) {
      settingsEvents.notify(updatedConfig.publicData.COMPONENT || {});
    },
    async onBeforeUnLoad() {
      router.dispose();
    },
    exports() {
      return {
        ready: ready.promise,
      };
    },
  };
};
